import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CollapsePanel from '../CollapsePanel/CollapsePanel';
import Adaptive from '../Adaptive/Adaptive';
import Grid from '../Utility/Grid';
import Text from '../BuildingBlocks/Text/Text';
import Amenity from './Amenity';

class AmenityList extends Component {
  static propTypes = {
    /** Array of available amentities */
    amenities: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        icon: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired
      })
    ).isRequired,
    /** Title above amenity list */
    title: PropTypes.string,
    /** Text visible in 'show all' button */
    openText: PropTypes.node,
    /** Text visible in 'hide' button */
    closeText: PropTypes.node,
    /** How many amenities are visible by default on lg/xl */
    visibleOnLarge: PropTypes.number,
    /** How many amenities are visible by default on sm/md */
    visibleOnSmall: PropTypes.number
  };

  static defaultProps = {
    title: 'Amenities',
    openText: 'See all',
    closeText: 'See less',
    visibleOnLarge: 6,
    visibleOnSmall: 4
  };

  constructor(props) {
    super(props);

    this.state = {};

    this.renderAmenities = this.renderAmenities.bind(this);
  }

  renderAmenities(visible) {
    const { amenities } = this.props;

    const visibleItems = amenities.slice(0, visible);
    let hiddenItems = amenities.slice(visible, amenities.length);

    // zero out hiddenItems just so it doesn't get a duplicate one
    if (visible >= amenities.length) {
      hiddenItems = null;
    }

    const amenityLayout = amenity => (
      <Grid.Col key={amenity.id} sm={12} md={6} lg={4}>
        <Amenity icon={amenity.icon} title={amenity.title} />
      </Grid.Col>
    );

    const visibleList = visibleItems.map(amenity => amenityLayout(amenity));

    let hiddenList = null;

    if (hiddenItems !== null) {
      hiddenList = hiddenItems.map(amenity => amenityLayout(amenity));
    }

    return { visibleList, hiddenList };
  }

  render() {
    const { title, visibleOnLarge, visibleOnSmall, openText, closeText } = this.props;

    const largeAmenities = this.renderAmenities(visibleOnLarge);
    const smallAmenities = this.renderAmenities(visibleOnSmall);

    return (
      <div style={{ margin: '5px 0' }}>
        <Text.HeadingFifth noMargins>{title}</Text.HeadingFifth>
        <Grid.Row>
          <Adaptive sm={smallAmenities.visibleList} lg={largeAmenities.visibleList} />
        </Grid.Row>

        <Adaptive
          sm={
            smallAmenities.hiddenList ? (
              <CollapsePanel openText={openText} closeText={closeText}>
                <Grid.Row>{smallAmenities.hiddenList}</Grid.Row>
              </CollapsePanel>
            ) : (
              <span />
            )
          }
          lg={
            largeAmenities.hiddenList ? (
              <CollapsePanel openText={openText} closeText={closeText}>
                <Grid.Row>{largeAmenities.hiddenList}</Grid.Row>
              </CollapsePanel>
            ) : (
              // Had to replace the content from sm with something or it would show the small content here
              <span />
            )
          }
        />
      </div>
    );
  }
}

export default AmenityList;
